import { Component, effect } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { CierreDiarioService } from '@cierreTurno/cierre-diario/services/cierre-diario.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-cierre-turno-index',
  templateUrl: './cierre-turno-index.component.html',
  styleUrls: ['./cierre-turno-index.component.css']
})
export class CierreTurnoIndexComponent {

  TipoUsuario = TipoUsuario;
  cargandoCierre: boolean;
  // etapa1:boolean;
  // etapa2:boolean;
  // etapa3:boolean;
  constructor(public authService: AuthService, public cierreDiarioService: CierreDiarioService) { 
    effect(() => { this.cargandoCierre = cierreDiarioService.loading()});
  }

}
